import { Box } from "@mui/material";
import { GREEN, LINE_2, ORANGE, PAPER, ROSE, ROSE_BG } from "./types";

/** Formen bär typen: cirkel = aktivitet, rundad kvadrat = ärende.
 *  Fyllningen bär statusen: grön = klar, orange kontur = att göra,
 *  rosa = försenad, delvis fylld (endast ärende) = delvis klart. */
export type MarkType = "activity" | "case";
export type MarkStatus = "done" | "todo" | "late" | "part";

interface StatusMarkProps {
  type: MarkType;
  status: MarkStatus;
  /** Andel klara aktiviteter, används vid status="part". */
  fraction?: number;
  size?: number;
}

const CheckIcon = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={3.2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12l4 4 10-10" />
  </svg>
);

const LateIcon = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={3.4}
    strokeLinecap="round"
  >
    <path d="M12 7v6M12 17h.01" />
  </svg>
);

const StatusMark = ({ type, status, fraction = 0, size = 21 }: StatusMarkProps) => {
  const iconSize = Math.round(size * 0.55);
  const pct = Math.round(Math.min(1, Math.max(0, fraction)) * 100);

  const styleByStatus = {
    done: { bgcolor: GREEN, borderColor: GREEN, color: "#fff" },
    todo: { bgcolor: PAPER, borderColor: ORANGE, color: "transparent" },
    late: { bgcolor: ROSE_BG, borderColor: ROSE, color: ROSE },
    part: {
      background: `conic-gradient(${ORANGE} 0 ${pct}%, transparent ${pct}%)`,
      borderColor: ORANGE,
      color: "transparent",
    },
  } as const;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        flex: "0 0 auto",
        display: "grid",
        placeItems: "center",
        border: `2px solid ${LINE_2}`,
        borderRadius: type === "activity" ? "50%" : `${Math.round(size * 0.29)}px`,
        ...styleByStatus[status],
      }}
    >
      {status === "done" && <CheckIcon size={iconSize} />}
      {status === "late" && <LateIcon size={iconSize} />}
    </Box>
  );
};

export default StatusMark;
